module.exports = __webpack_public_path__ + "static/media/Linus_Logo.a1efc1b9.avif";